// Toile's own header slots — the shared chrome (sticky, reveal, `.brand`/`.nav`/`.right` layout) is
// `@core/wall/ui/Header.module.scss` now; this file keeps only what is specific to Toile's own
// wordmark and nav-link styling.

.word {
    font-family: var(--tl-font);
    font-weight: 500;
    font-size: 17px;
    letter-spacing: -0.02em;
    line-height: 1;
    color: var(--tl-text);
    text-transform: lowercase;
}

.navLink,
.navLinkOn {
    font-size: 13px;
    color: var(--tl-muted);
}

.navLinkOn {
    color: var(--tl-text);
}

@media (max-width: 640px) {
    // The word yields to the mark (plan 2026_09_04_wall_header_reveal.md § Step 2, Decisions and
    // wording: "collapsing the mark on mobile to just the mark is clever" — the operator). The
    // shared shell hides its own `.nav` slot at the same 640px threshold.
    .word {
        display: none;
    }
}
